import { useState, useCallback, useEffect } from 'react'
import { useRouter } from 'next/router'
import PropTypes from 'prop-types'
import { Notice } from '@pretamanger/component-library'
import { translate } from '#src/common/components/translation'
import { BagItemQuantity } from '#src/common/components/bag/bag-items/bag-item-quantity'
import {
  BagItemContainer,
  BagItemContainerRow,
  BagItemTitle,
  BagItemTitleContainer,
  BagItemTitleUnavailable,
  BagItemQuantityContainer,
  TotalBagItemPrice,
  TotalBagItemPriceUnavailable,
  BagItemSubTitle
} from './styles'

import {
  getAdditionalAttributes,
  renderTotalPriceLabel,
  renderAdditionalAttributesString
} from '#src/common/components/bag/bag-utils'

const BagItem = ({ item, onQuantityChange }) => {
  const { locale } = useRouter()
  const [quantity, setQuantity] = useState(item.recalculatedLineItem.quantity)
  const { available } = item.availability
  const { id, name, totalPrice } = item.recalculatedLineItem

  useEffect(() => {
    setQuantity(item.recalculatedLineItem.quantity)
  }, [item])

  const onSelect = useCallback(
    value => {
      const previousQuantity = quantity
      setQuantity(value)
      onQuantityChange(item, parseInt(value, 10), previousQuantity)
    },
    // todo this ought to be fixed
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [id]
  )

  const additionalAttributes = getAdditionalAttributes(
    item.recalculatedLineItem,
    locale
  )

  return (
    <BagItemContainer data-testid='bag-item-container'>
      <BagItemContainerRow>
        <BagItemQuantityContainer>
          <BagItemQuantity
            id={id}
            handleChange={onSelect}
            quantity={quantity}
            visible={available}
          />
        </BagItemQuantityContainer>
        {available ? (
          <>
            <BagItemTitleContainer>
              <BagItemTitle id={`bag-title-${id}`}>{name}</BagItemTitle>
              {additionalAttributes.length > 0 && (
                <BagItemSubTitle>
                  {renderAdditionalAttributesString(additionalAttributes)}
                </BagItemSubTitle>
              )}
            </BagItemTitleContainer>
            <TotalBagItemPrice>
              {renderTotalPriceLabel(totalPrice, locale)}
            </TotalBagItemPrice>
          </>
        ) : (
          <>
            <BagItemTitleContainer>
              <BagItemTitleUnavailable id={`bag-title-${id}`}>
                {name}
              </BagItemTitleUnavailable>
              {additionalAttributes.length > 0 && (
                <BagItemSubTitle>
                  {renderAdditionalAttributesString(additionalAttributes)}
                </BagItemSubTitle>
              )}
            </BagItemTitleContainer>
            <TotalBagItemPriceUnavailable>
              {renderTotalPriceLabel(totalPrice, locale)}
            </TotalBagItemPriceUnavailable>
          </>
        )}
      </BagItemContainerRow>
      {!available && (
        <Notice
          title={
            translate('product.add-items-to-bag.product-not-available', locale)
              ?.value
          }
          variant='info'
        />
      )}
    </BagItemContainer>
  )
}

BagItem.propTypes = {
  item: PropTypes.object.isRequired,
  onQuantityChange: PropTypes.func.isRequired
}

export default BagItem
